module.exports = __webpack_public_path__ + "static/photo_booth-9f6af0d34434c1f231992419b10a12e3.jpg";